import { SITE_NAMES_MOCK } from '@hapana/shared/web/mocks/site.mocks'

import { V1_SITE_ID } from '@hapana/shared/constants/tests.constants'

import { siteIdQuery, siteNamesQuery, sitesListQuery } from './graphql/site.queries'
import { gqlQuery } from './requests.service'

export const getSiteId = gqlQuery({
  key: 'V1_SITE_ID',
  query: siteIdQuery,
  mockResponse: { site: { id: V1_SITE_ID } },
})

export const getSiteNames = (siteIds = []) =>
  gqlQuery({
    key: 'SITE_NAMES',
    query: siteNamesQuery(siteIds ?? []),
    mockResponse: SITE_NAMES_MOCK,
  })

export const getSitesList = gqlQuery({
  key: 'SITES_LIST',
  query: sitesListQuery,
  mockResponse: {
    sites: {
      results: [
        {
          node: {
            id: '1',
            name: 'Main Gym',
            address: '123 Main St',
            status: 'active',
          },
        },
        {
          node: {
            id: '2',
            name: 'Branch Location',
            address: '456 Oak Ave',
            status: 'active',
          },
        },
      ],
    },
  },
  options: {},
})
